<template>
  <fieldset>
    <FormulateInput
      type="select"
      :name="fieldName"
      :options="options"
      :label="i18n.form.labels.city"
      :help="i18n.form.help.city"
      validation="required"
      :validation-messages="i18n.form.validations.city"
      error-behavior="blur"
    />
    <kf-loader
      v-if="isLoading"
      loader-size="sm"
      loader-color="primary"
    />
  </fieldset>
</template>

<script>
import KfLoader from '@/components/loader/Loader.vue';
import axios from 'axios';

export default {
  name: 'FieldsDropdownCities',
  components: {
    KfLoader,
  },
  props: {
    i18n: {
      type: Object,
      default: () => {},
    },
    fieldName: {
      type: String,
      default: () => 'city',
    },
    label: {
      type: String,
      default: () => 'Smallsteps',
    },
  },
  data() {
    return {
      options: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getCityOptions().then((o) => (this.options = o));
  },
  methods: {
    getCityOptions() {
      this.isLoading = true;
      return new Promise((resolve, reject) => {
        axios
          .get(`/umbraco/api/content/getcities?label=${this.label}`)
          .then((response) => {
            const data = response.data;
            const cities = [
              { value: '', label: `-- ${this.i18n.form.labels.city.toLowerCase()} --` },
            ];
            data.Location.forEach((loc) => {
              const city = this.formatCity(loc.city);
              cities.push({ value: loc.city, label: city });
            });
            resolve(cities);
          })
          .catch((e) => {
            console.log(e);
            reject(e);
          })
          .finally(() => {
            this.isLoading = false;
          });
      });
    },
    formatCity(city) {
      // capitalize first letter
      let fCity = city.charAt(0).toUpperCase() + city.slice(1).toLowerCase();

      // if starts with an 'IJ'
      if (fCity.charAt(0) === 'I' && fCity.charAt(1) === 'j') {
        fCity =
          fCity.charAt(0).toUpperCase() +
          fCity.charAt(1).toUpperCase() +
          fCity.slice(2).toLowerCase();
      }

      // capitalize after '-'
      const dashIndex = fCity.indexOf('-');
      if (dashIndex > -1) {
        fCity =
          fCity.slice(0, dashIndex + 1) +
          fCity.charAt(dashIndex + 1).toUpperCase() +
          fCity.slice(dashIndex + 2);
      }

      // capitalize after last ' '
      const spaceIndex = fCity.lastIndexOf(' ');
      if (spaceIndex > -1) {
        fCity =
          fCity.slice(0, spaceIndex + 1) +
          fCity.charAt(spaceIndex + 1).toUpperCase() +
          fCity.slice(spaceIndex + 2);
      }
      return fCity;
    },
  },
};
</script>
